import { render, staticRenderFns } from "./Promote.vue?vue&type=template&id=5fb1710c&scoped=true&"
import script from "./Promote.vue?vue&type=script&lang=js&"
export * from "./Promote.vue?vue&type=script&lang=js&"
import style0 from "./Promote.vue?vue&type=style&index=0&id=5fb1710c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb1710c",
  null
  
)

export default component.exports